import { render, staticRenderFns } from "./SecondarySidebar.vue?vue&type=template&id=662391cc&scoped=true"
import script from "./SecondarySidebar.vue?vue&type=script&lang=js"
export * from "./SecondarySidebar.vue?vue&type=script&lang=js"
import style0 from "./SecondarySidebar.vue?vue&type=style&index=0&id=662391cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662391cc",
  null
  
)

export default component.exports